import { render, staticRenderFns } from "./SearchSelectCommodity.vue?vue&type=template&id=989672de&scoped=true&"
import script from "./SearchSelectCommodity.vue?vue&type=script&lang=js&"
export * from "./SearchSelectCommodity.vue?vue&type=script&lang=js&"
import style0 from "./SearchSelectCommodity.vue?vue&type=style&index=0&id=989672de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989672de",
  null
  
)

export default component.exports